import type { FunctionComponent } from 'react';
import SidebarNavLayout from '../../layouts/SidebarNavLayout';
import SettingsPage from '../../shared/settings/SettingsPage';
import type { RouterProps } from '../../../types';

type Props = RouterProps;

/**
 * OrganizationAuditLogsSettings is the top-level wrapper component for
 * all the audit logs.
 */
const OrganizationAuditLogsSettings: FunctionComponent<Props> = ({ children, location }) => (
  <SidebarNavLayout>
    <SidebarNavLayout.Nav pathname={location.pathname}>
      <SidebarNavLayout.NavHeading>
        Audit Logs
      </SidebarNavLayout.NavHeading>
      <SidebarNavLayout.NavItem to="/account/settings/audit-logs" activeKey="audit-logs">
        All
      </SidebarNavLayout.NavItem>
      <SidebarNavLayout.NavItem to="/account/settings/audit-logs/users" activeKey="users">
        Users
      </SidebarNavLayout.NavItem>
      <SidebarNavLayout.NavItem to="/account/settings/audit-logs/issues" activeKey="issues">
        Issues
      </SidebarNavLayout.NavItem>
    </SidebarNavLayout.Nav>
    <SidebarNavLayout.Content>
      <SettingsPage isUnpadded>
        {children}
      </SettingsPage>
    </SidebarNavLayout.Content>
  </SidebarNavLayout>
);

export default OrganizationAuditLogsSettings;
